// extracted by mini-css-extract-plugin
export default {"container":"Title-module__container--iESYk","anchor":"Title-module__anchor--uebmc","truncate":"Title-module__truncate--BAKr7","trailingBadges":"Title-module__trailingBadges--rIk0t"};